import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-foreground-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-500">
                <i className="ri-book-open-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">妖精漫画</span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed max-w-xs">
              妖精漫画网是最全的韩国漫画在线阅读平台，提供下拉式韩漫大全、免费漫画在线观看服务。每日更新海量热门韩漫，为您带来极致的漫画阅读体验。
            </p>
            <div className="flex items-center gap-3 mt-6">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-700 text-foreground-200 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-700 text-foreground-200 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-700 text-foreground-200 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="QQ">
                <i className="ri-qq-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 tracking-wide">热门分类</h4>
            <div className="flex flex-col gap-2.5">
              {categories.slice(0, 6).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 tracking-wide">网站导航</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">首页推荐</Link>
              <Link to="/category/romance" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">热门排行</Link>
              <Link to="/category/fantasy" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">最新上架</Link>
              <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">关于我们</Link>
              <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">联系我们</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 tracking-wide">帮助中心</h4>
            <div className="flex flex-col gap-2.5">
              <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">用户协议</a>
              <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">隐私政策</a>
              <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">版权声明</a>
              <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">帮助中心</a>
              <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">反馈建议</a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-700">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 妖精漫画网 Yaoread.com · 本站内容仅供学习交流，请勿用于商业用途
          </p>
          <div className="flex items-center gap-2 text-xs text-foreground-500">
            <a href="#" className="hover:text-primary-400 transition-colors">用户协议</a>
            <span>|</span>
            <a href="#" className="hover:text-primary-400 transition-colors">隐私政策</a>
            <span>|</span>
            <a href="#" className="hover:text-primary-400 transition-colors">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}